<template>
  <card additional-classes="slds-card_boundary full-height">
    <!-- Name, Market -->
    <div class="row">
      <!-- Name -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <Input
            :label="$t('fastCounter.previewSetup.previewName')"
            :validation="['required']"
            ref="data_name"
            v-if="isCreate || isEdit"
            v-model="name" />

          <output-field
            :label="$t('campaignDesigner.campaignSetup.name')"
            :value="name"
            v-else />
        </div>
      </div>

      <!-- Market -->
      <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <picklist
            sort-label
            :label="$t('fastCounter.previewSetup.market')"
            :options="localConfig.previewData.markets.options"
            :validation="['required']"
            labels-prefix="markets"
            multipicklist
            ref="data_market"
            v-if="isCreate || isEdit"
            v-model="markets" />

          <output-field
            :label="$t('campaignDesigner.campaignSetup.market')"
            :options="localConfig.previewData.markets.options"
            :value="markets"
            labels-prefix="markets"
            type="multipicklist"
            v-else />
        </div>
      </div>
    </div>
    <!-- Brand -->
    <div class="row">
      <!-- Brand -->
      <!-- <div class="slds-form-element col">
        <div class="slds-form-element slds-size--medium">
          <picklist
            :label="$t('fastCounter.previewSetup.brand')"
            :options="localConfig.previewData.brands.options"
            :validation="['required']"
            labels-prefix="brands"
            multipicklist
            ref="data_brand"
            v-if="isCreate || isEdit"
            v-model="brands" />

          <output-field
            :label="$t('fastCounter.previewSetup.brand')"
            :options="localConfig.previewData.brands.options"
            :value="brands"
            labels-prefix="brands"
            type="multipicklist"
            v-else />
        </div>
      </div> -->
    </div>
  </card>
</template>
<script>
import _ from 'lodash'
import Card from '../slds/Card'
import HasMode from '../utils/HasMode'
import Input from '../slds/Input'
import OutputField from '../slds/OutputField'
import Picklist from '../slds/Picklist'
import { mapGetters } from 'vuex'
import { validate } from '../utils/utils'
export default {
  mixins: [HasMode],
  components: {
    Card,
    Input,
    OutputField,
    Picklist
  },
  props: {
    config: Object,
    mode: String
  },
  data () {
    return {
      localConfig: {},
      // brands: [],
      name: '',
      markets: []
    }
  },
  methods: {
    validate() {
      return validate(this, 'data_')
    },
    getSectionToSave () {
      return {
        flat: {
          name: this.name
        },
        config: {
          markets: {
            options: this.localConfig.previewData.markets.options,
            selected: this.markets
          }//,
          // brands: {
          //   options: this.localConfig.previewData.brands.options,
          //   selected: this.brands
          // }
        }
      }
    },
    callLoadFromStore () {
      this.localConfig = _.cloneDeep(this.config)
      const preview = this.$store.getters['fastCounter/currentPreview']

      this.name = preview.name
      this.markets = preview.marketCodes
      // this.brands = preview.brands
    }
  },
  created () {
    this.callLoadFromStore()
  },
  computed: {
    ...mapGetters({
      currentPreview: 'fastCounter/currentPreview'
    })
  }
}
</script>
<style lang="scss" scoped>
  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-start;
  }

  .col {
    flex-grow: 1;
  }

  Input {
    width: unset !important;
  }
</style>
